import { APPLE_COMMAND_KEY } from './constants';
/**
 * The german translations.
 */
export const de = {
    gestureHandlingTouch: 'Verschieben der Karte mit zwei Fingern',
    gestureHandlingScroll: 'Verwende Strg + Scrollen zum Zoomen der Karte',
    gestureHandlingScrollMac: `Verwende ${APPLE_COMMAND_KEY} + Scrollen zum Zoomen der Karte`,
    Transparency: 'Transparenz',
};
//# sourceMappingURL=de.js.map